// @flow
import { connect } from "react-redux";
import BlogCardList from "./view";
import BlogCard from "../../blog-card";

export default connect(
    state => ({
        blogs: state.blogs.all,
        BlogCardList,
        BlogCard
    }),
    () => ({})
)(BlogCardList);



// WEBPACK FOOTER //
// ./src/home-page-view/blog-card-list/index.js